import fetch from "./fetch";
import { downloadUrl } from "@/utils/exportData";

/**
 * 公用导出方法
 */
const exportFiles = {
  //活动分页
  getExportFiles(url, params) {
    return fetch({
      isLoading: true,
      url: url,
      method: "GET",
      params,
      responseType: "blob",
      commonExport: true,
    });
  },

  downloadExportCommon(url, params) {
    console.log("params", params);
    this.getExportFiles(url, params).then((res) => {
      console.log("文件流处理：-------------", res);
      let data = res.data;
      let dis = res.headers["content-disposition"];
      if (!dis) {
        return;
      }
      let fileName = decodeURIComponent(dis.split("attachment;filename=")[1]);
      downloadUrl(data, fileName);
    });
  },
};

export default exportFiles;
